export default __webpack_public_path__ + "static/anselmay1-4bc38a15cd4652f6d74cc2645851273b.jpg";